import Vue from 'vue';
import contactTransformer from './../../transformers/contact';
import store from './../../store';

const success = ({ data }, resolve) => {
  store.dispatch('getContact', contactTransformer.fetch(data));

  resolve(contactTransformer.fetch(data));
};

const failed = () => {};

export default () => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.get('contacts')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/contact/show.js